import { render, staticRenderFns } from "./generalframe.vue?vue&type=template&id=6eb3779d&scoped=true&"
import script from "./generalframe.vue?vue&type=script&lang=js&"
export * from "./generalframe.vue?vue&type=script&lang=js&"
import style0 from "./generalframe.vue?vue&type=style&index=0&id=6eb3779d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb3779d",
  null
  
)

export default component.exports